import {
	Divider,
	IconButton,
	ListItemIcon,
	makeStyles,
	Menu,
	MenuItem,
} from "@material-ui/core";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import SettingsIcon from "@material-ui/icons/Settings";
import { get } from "lodash";
import React from "react";
import { useRedirect, useTranslate } from "react-admin";
import {
	BookmakerBlacklistIcon,
	BookmakerChannelIcon,
	BookmakerImport,
	BookmakerLandingIcon,
	BookmakerWhitelistIcon,
} from "../../icons";
import CreateChannelsButton from "../CreateChannelsButton";
import ImportButton from "../ImportButton";

const useStyles = makeStyles({
	divider: {
		marginTop: ".5em",
		marginBottom: ".5em",
	},
});

const SettingsField = ({ record }) => {
	const translate = useTranslate();
	const redirect = useRedirect();
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOpen = (resource) => {
		setAnchorEl(null);
		redirect(
			`/${resource}?filter=${encodeURIComponent(
				JSON.stringify({
					bookmaker_id: get(record, "id"),
				})
			)}`
		);
	};
	return (
		<>
			<IconButton
				aria-controls="simple-menu"
				aria-haspopup="true"
				title={translate("resources.bookmakers.fields.settings.help")}
				onClick={handleClick}
			>
				<SettingsIcon />
			</IconButton>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem onClick={handleOpen.bind(this, "bookmaker-landings")}>
					<ListItemIcon>
						<BookmakerLandingIcon size="small" />
					</ListItemIcon>
					{translate("menu.items.bookmaker-landings")}
				</MenuItem>
				<MenuItem onClick={handleOpen.bind(this, "bookmaker-channels")}>
					<ListItemIcon>
						<BookmakerChannelIcon size="small" />
					</ListItemIcon>
					{translate("menu.items.bookmaker-channels")}
				</MenuItem>
				<MenuItem onClick={handleOpen.bind(this, "bookmaker-blacklists")}>
					<ListItemIcon>
						<BookmakerBlacklistIcon size="small" />
					</ListItemIcon>
					{translate("menu.items.bookmaker-blacklists")}
				</MenuItem>
				<MenuItem onClick={handleOpen.bind(this, "bookmaker-whitelists")}>
					<ListItemIcon>
						<BookmakerWhitelistIcon size="small" />
					</ListItemIcon>
					{translate("menu.items.bookmaker-whitelists")}
				</MenuItem>
				<Divider className={classes.divider} />
				<MenuItem
					onClick={() =>
						redirect(
							`/bookmaker-imports/create?source=${JSON.stringify({
								bookmaker_id: get(record, "id"),
							})}`
						)
					}
				>
					<ListItemIcon>
						<ImportContactsIcon size="small" />
					</ListItemIcon>
					{translate("resources.bookmaker-imports.create")}
				</MenuItem>
				<MenuItem onClick={handleOpen.bind(this, "bookmaker-imports")}>
					<ListItemIcon>
						<BookmakerImport size="small" />
					</ListItemIcon>
					{translate("menu.items.bookmaker-imports")}
				</MenuItem>
				<Divider className={classes.divider} />
				<CreateChannelsButton record={record} />
				<ImportButton record={record} />
			</Menu>
		</>
	);
};

export default SettingsField;
